import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

export default function useAutoTimeout(duration = 19 * 60 * 1000) {
  const history = useHistory();
  const [scrollY, setScrollY] = useState(0);
  const [open, setOpen] = useState(false);
  const [hasRedirected, setHasRedirected] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);

    const timeout = setTimeout(() => {
      if (!hasRedirected) setOpen(true);
    }, duration);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeout);
    };
  }, [hasRedirected, duration]);

  useEffect(() => {
    if (open) {
      const redirectTimeout = setTimeout(() => {
        setHasRedirected(true);
        setOpen(false);
        history.push('/hotels');
      }, 60000);

      return () => clearTimeout(redirectTimeout);
    }
  }, [open, history]);

  const handleContinue = () => {
    setOpen(false); // cierra el modal
    window.location.reload(); // recarga la página
  };

  const handleScrollToTop = () =>
    window.scrollTo({ top: 0, behavior: 'smooth' });

  return { scrollY, open, handleContinue, handleScrollToTop };
}
